import * as moment from 'moment';
import { DateUtils } from '../../../../../utils/date-utils';

export const INTERNAL_PAYMENT_CUTOFF_DAY = 5;
export const MEMBERS_PAYMENT_CUTOFF_DAY = 5;

export function computeFirstValidPaymentStart(
  effectiveDate: string,
  cutoffDay: number = INTERNAL_PAYMENT_CUTOFF_DAY
): { month: number; year: number } {
  const today = moment(DateUtils.todayInCST());
  const effectiveStart = moment(effectiveDate).startOf('month');
  const cutoffPassed = today.date() > cutoffDay;
  const firstOpenMonth = cutoffPassed ? today.clone().startOf('month').add(1, 'month') : today.clone().startOf('month');
  const resultMoment = effectiveStart.isAfter(firstOpenMonth) ? effectiveStart : firstOpenMonth;
  const maxYear = today.year() + 1;
  if (resultMoment.year() > maxYear) {
    return { month: 12, year: maxYear };
  }
  return { month: resultMoment.month() + 1, year: resultMoment.year() };
}

export interface RecurringPaymentStartConstraints {
  effectiveDateFloor: { month: number; year: number };
  cutoffFloor: { month: number; year: number };
  maxYear: number;
}

export function computeRecurringPaymentStartConstraints(
  effectiveDate: string,
  cutoffDay: number = INTERNAL_PAYMENT_CUTOFF_DAY
): RecurringPaymentStartConstraints {
  const today = moment(DateUtils.todayInCST());
  const maxYear = today.year() + 1;

  const effectiveStart = moment(effectiveDate).startOf('month');
  const effectiveDateFloor =
    effectiveStart.year() > maxYear
      ? { month: 12, year: maxYear }
      : { month: effectiveStart.month() + 1, year: effectiveStart.year() };

  const cutoffPassed = today.date() > cutoffDay;
  const firstOpenMonth = cutoffPassed ? today.clone().startOf('month').add(1, 'month') : today.clone().startOf('month');
  const cutoffFloor = { month: firstOpenMonth.month() + 1, year: firstOpenMonth.year() };

  return { effectiveDateFloor, cutoffFloor, maxYear };
}
